<template>
  <div class="app-preloader">
    <Logo />
    <span class="app-preloader__text">
      Allposit initialization
      <span class="app-preloader__dots">
        <span class="app-preloader__dot" />
        <span class="app-preloader__dot" />
        <span class="app-preloader__dot" />
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import Logo from '../Logo/Logo.vue'

defineOptions({
  name: 'AppPreloader',
})
</script>

<style>
.app-preloader {
  @apply fixed inset-0;
  @apply flex justify-center items-center;
  @apply gap-x-1;
  @apply bg-primary;
  @apply z-30;
  @apply text-indigo-200;

  &__dots {
    @apply inline-flex;
  }

  &__dot {
    @apply after:content-['.'];

    &:first-child {
      @apply animate-[jump_1s_250ms_ease-in-out_infinite];
    }

    &:nth-child(2) {
      @apply animate-[jump_1s_500ms_ease-in-out_infinite];
    }

    &:last-child {
      @apply animate-[jump_1s_750ms_ease-in-out_infinite];
    }
  }
}

@keyframes jump {
  50% {
    @apply -translate-y-1;
  }
}
</style>
